import { t } from "@/i18n-js/instance";
import { localeRoot } from "../../constants";
import {
  ContainerForm,
  useContainerEnabledForm,
} from "../Properties/components/ContainerForm";
import { FormGroup } from "../Properties/components/FormGroup";
import { ReducedPricesForm } from "./ReducedPricesForm";

const containerDataTestId = "paywall-customization-reduced-prices-container";

export const ReducedPriceProperties = () => (
  <ContainerForm
    containerDataTestId={containerDataTestId}
    containerClassName="pt-0"
    descriptionLocale={t([localeRoot, "builder.reduced_prices.description"])}
    useHooks={useContainerEnabledForm}
  >
    <FormGroup
      data-testid="reduced-prices-properties-form-group"
      className="space-y-0 divide-y-0"
      isEnabled
    >
      <ReducedPricesForm />
    </FormGroup>
  </ContainerForm>
);
